import { useContext, useEffect, useState } from 'react';
import ReactModal from 'react-modal';

import { GroupDetailInterface, UserGroupInterface } from 'types/user';
import { ModalContext } from 'context/ModalContext';
import { useAuth } from 'context/AuthContext';
import { getUserGroup, getUserGroupList } from 'services/dashboard.service';

import { IoIosClose } from 'react-icons/io';

type Props = {
  player?: string;
  returnTotal?: (value: number) => void;
};

export function GroupDetailModalExtrato({ player, returnTotal }: Props) {
  const { user } = useAuth();
  const { openModal, closeModal } = useContext(ModalContext);

  const modalID = 'group-detail-extrato';

  const [modalIsOpen, setIsOpen] = useState<boolean>(false);
  const [data, setData] = useState<any>([]);

  ReactModal.setAppElement('#modal');

  function handleCloseModal() {
    //
  }

  function afterOpenModal() {
    //
  }

  useEffect(() => {
    setIsOpen(openModal === modalID);
  }, [openModal]);

  useEffect(() => {
    async function loadUserGroup() {
      if (user?._id || player) {
        const data = await getUserGroupList(player);
        setData(data);

        if (returnTotal) {
          returnTotal(data?.length);
        }
      }
    }

    if (!user) return;

    loadUserGroup();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [user, player]);

  if (!data?.length) return <></>;

  return (
    <>
      <ReactModal
        shouldCloseOnOverlayClick={false}
        isOpen={modalIsOpen}
        onAfterOpen={afterOpenModal}
        onRequestClose={handleCloseModal}
        contentLabel="Example Modal"
        portalClassName="relative z-50"
        overlayClassName="rb-modal-overlay rb-modal-overlay--top"
        contentElement={() => (
          <div className="rb-modal rb-modal--lg">
            <button className="rb-modal__close" aria-label="Fechar" onClick={() => closeModal()}>
              <IoIosClose size={26} />
            </button>

            <div className="rb-modal__header">
              <h1 className="rb-modal__title">Grupo {data[0]?.grupo}</h1>
            </div>

            <div className="overflow-x-auto">
              <table>
                <thead>
                  <tr>
                    <th>E-mail</th>
                    <th>Nome</th>
                  </tr>
                </thead>
                <tbody>
                  {data.map((group: any) => (
                    <tr key={group._id}>
                      <td>{group.chave}</td>
                      <td>{group.nome}</td>
                    </tr>
                  ))}
                </tbody>
              </table>
            </div>

            <p className="rb-modal__text">
              Total de funcionários do grupo: <strong>{data?.length} pessoas.</strong>
            </p>
          </div>
        )}
      />
    </>
  );
}
